export default __webpack_public_path__ + "static/datelabel-dropdown-dont-3-light-30dabc315a3a637e89082e98c57712f3.png";